export class VenueServices {
    id: string;


    /**
     * number of tables
     */
    tables: number;

    tableService: boolean;

    takeaway: boolean;

    delivery: boolean;

    /**
     * Number of stores within the venue. Default 1
     */
    storeLimit: number;
}
